import React from "react";

export default function SQL_ALL() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">SQL_ALL</h1>
      <p>This is the SQL_ALL component generated from the SQL JSON.</p>
    </div>
  );
}
